import { Calculator } from "lucide-react";

import MetaCmv from "./MetaCmv";
import SeuPreco from "./SeuPreco";
import useMetasCmv from "./useMetasCmv";
import { brl } from "./lib/precos";

/** Card "Precificação" da Ficha Técnica (pedido do dono, 02/10/2026): o preço
 *  de venda para 3 metas de CMV (padrão 25/30/35%, editáveis, valem para a loja
 *  toda), com markup simples (preço ÷ custo), e o preço do produto editável
 *  aqui mesmo. Não grava preço sozinho: muda o campo e o Salvar grava. */
export default function CardPrecificacao({ custo, preco, setPreco, rotulo, sufixo }) {
  const { metas, trocarMeta } = useMetasCmv();
  const semCusto = !(custo > 0);

  return (
    <section data-e2e="card-precificacao" className="bg-card rounded-2xl border shadow-sm overflow-hidden">
      <header className="px-4 py-3 border-b bg-gradient-to-r from-emerald-50/80 to-teal-50/60 dark:from-emerald-950/20 dark:to-teal-950/10 flex items-center gap-2.5">
        <div className="w-8 h-8 rounded-lg bg-emerald-500/15 flex items-center justify-center flex-shrink-0">
          <Calculator className="w-4 h-4 text-emerald-600 dark:text-emerald-400" />
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="text-sm font-bold text-foreground">Precificação</h3>
          <p className="text-[11px] text-muted-foreground">
            Preço de venda para cada meta de CMV · markup = preço ÷ custo
            {!semCusto && <> · custo <strong className="text-foreground">{brl(custo)}</strong></>}
          </p>
        </div>
      </header>

      <div className="p-4 grid grid-cols-1 lg:grid-cols-[1fr_300px] gap-3">
        {semCusto ? (
          <div className="rounded-xl border border-dashed p-4 flex items-center justify-center text-center text-xs text-muted-foreground">
            Adicione ingredientes ou embalagens na ficha abaixo para ver os preços sugeridos.
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
            {metas.map((meta, i) => (
              <MetaCmv
                key={i}
                indice={i}
                meta={meta}
                custo={custo}
                precoAtual={preco}
                sufixo={sufixo}
                onTrocarMeta={trocarMeta}
                onUsar={(p) => setPreco(p.toFixed(2))}
              />
            ))}
          </div>
        )}
        <SeuPreco custo={custo} preco={preco} setPreco={setPreco} rotulo={rotulo} sufixo={sufixo} />
      </div>
    </section>
  );
}
